import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "expand-panel" };
const _hoisted_2 = { class: "px-2 pe-3" };
const _hoisted_3 = {
    class: "flex-grow-1",
    style: { "min-width": "0" }
};
const _hoisted_4 = {
    class: "flex-grow-1",
    style: { "min-width": "0" }
};
const _hoisted_5 = { class: "px-2 ps-3" };
const _hoisted_6 = {
    key: 0,
    class: "expand-panel__content"
};
const _hoisted_7 = { class: "body" };
const _hoisted_8 = {
    key: 0,
    class: "footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_collapse_transition = _resolveComponent("g-collapse-transition");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
            class: "header cursor-pointer d-flex",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
            //@ts-ignore
            (...args) => (_ctx.toggle && _ctx.toggle(...args)), ["prevent"]))
        }, [
            (_ctx.arrowLocation === 'left')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", {
                            class: _normalizeClass(['arrow', _ctx._IsExpanded ? 'up' : 'down'])
                        }, null, 2)
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _renderSlot(_ctx.$slots, "header")
                    ])
                ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_4, [
                        _renderSlot(_ctx.$slots, "header")
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", {
                            class: _normalizeClass(['arrow', _ctx._IsExpanded ? 'up' : 'down'])
                        }, null, 2)
                    ])
                ], 64))
        ]),
        _createVNode(_component_g_collapse_transition, { duration: 300 }, {
            default: _withCtx(() => [
                (_ctx._IsExpanded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _renderSlot(_ctx.$slots, "body")
                        ]),
                        (_ctx.$slots.footer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _renderSlot(_ctx.$slots, "footer")
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ]),
            _: 3
        })
    ]));
}
